import React from "react";
import SideNavLayout from "@/layouts/SideNavLayout";
import ApplicationTabContent from "@/components/tabs/ApplicationTabContent";
import AppHeader from "@/components/headers/AppHeader";

import "@/styles/scss/pages/_applications.scss";

const ApplicationPage = () => {
  return (
    <div className="applications-page">
      <SideNavLayout appBar={false}>
        <div className="bg-success p-3 sticky">
          <div className="row text-white">
            <div className="col">Alista | Willow Bridge | 955-458-9564</div>
            <div className="col">
              <div className="float-end">
                <button className="btn btn-success btn-sm me-2">
                  <i className="bi bi-house me-1" />
                  Property Settings
                </button>
                <button className="btn btn-success btn-sm me-2">
                  <i className="bi bi-gear me-1" />
                  View Brick
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="p-3">
          <div className="row">
            <div className="col">
              <AppHeader />
            </div>
            <div className="col">
              <div>
                <button className="btn btn-danger btn-sm me-2">
                  <i className="bi bi-archive me-1" />
                  Documents
                </button>
                <button className="btn btn-danger btn-sm me-2">
                  <i className="bi bi-chat me-1" />
                  Messages
                </button>
                <button className="btn btn-danger btn-sm me-2">
                  <i className="bi bi-check me-1" />
                  <span>Tasks</span>
                  <span className="badge bg-white text-danger ms-1 rounded">
                    3
                  </span>
                </button>
              </div>
            </div>
          </div>
          <ApplicationTabContent />
        </div>
      </SideNavLayout>
    </div>
  );
};

ApplicationPage.propTypes = {};

export default ApplicationPage;
